import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M9.829 2.149A2 2 0 0 1 12.087.447L21 1.699a2 2 0 0 1 1.702 2.26l-1.53 10.892a2 2 0 0 1-2.26 1.702l-1.572-.22-.566-4.12 2.695.38L20.72 3.68l-8.91-1.253-.289 2.056-2.064.315.373-2.65Z"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 7.7a2 2 0 0 0-1.702 2.258l1.53 10.893a2 2 0 0 0 2.26 1.703L14 21.3a2 2 0 0 0 1.702-2.259l-1.53-10.893a2 2 0 0 0-2.26-1.702L3 7.699Zm1.686 4.812a1 1 0 1 0-.278-1.98 1 1 0 0 0 .278 1.98Zm8.061-.123.835 5.941-8.912 1.253 2.841-4.035 1.922 1.548 3.314-4.707Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconPlaceholderImages24 = createIcon(IconComponent);